module.exports = __webpack_public_path__ + "static/img/new_game_2.38b6cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/new_game_2.png
// module id = cfQx
// module chunks = 1